<template>
  <div class="c-epg-view-switch">
    <i
      class="o-icon o-icon--list o-typography--action o-typography--stateful"
      :class="{ 'is-active': isActiveTab('epg') }"
      @click="switchTab('epg')"
    ></i>
    <i
      class="o-icon o-icon--grid o-typography--action o-typography--stateful"
      :class="{ 'is-active': isActiveTab('channels') }"
      @click="switchTab('channels')"
    ></i>
  </div>
</template>
<script>
  export default {
    computed: {
      currentTab() {
        if (this.$window.isMobileView) {
          return 'channels';
        }

        return this.$storage.epgTab || 'epg';
      },
    },
    methods: {
      isActiveTab(tab) {
        return tab === this.currentTab;
      },
      switchTab(tab) {
        this.$storage.epgTab = tab;
      },
    },
  };
</script>
